import { ORDERS_STATUS_MESSAGES, OrdersStatusMessages } from "./order-status.messages";
import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";

export type OrdersFiltersMessages = FiltersMessages &
  OrdersStatusMessages & {
    salesChannelOption: string;
    orderNumberOption: string;
    buyerOption: string;
    statusOption: string;
    dateOption: string;
    skuOption: string;
    orderAmountOption: string;
    categoryOption: string;
    categoryPlaceholder: string;
    moreFilters: string;
    lessFilters: string;
    cleanFilters: string;
    startDate: string;
    endDate: string;
  };

export const ORDERS_FILTER_MESSAGES: OrdersFiltersMessages = {
  ...FILTER_MESSAGES,
  salesChannelOption: "Canal de Vendas",
  orderNumberOption: "Número do Pedido",
  buyerOption: "Cliente",
  statusOption: "Status",
  dateOption: "Data",
  skuOption: "Sku",
  orderAmountOption: "Valor",
  categoryOption: "Categoria",
  categoryPlaceholder: "Selecione uma categoria",
  moreFilters: "Mais Filtros",
  lessFilters: "Menos Filtros",
  cleanFilters: "Limpar Filtros",
  startDate: "Data Início",
  endDate: "Data Fim",

  ...ORDERS_STATUS_MESSAGES,
};
